import axios from 'axios'

type setAttachmentProps = {
    fileinfo: File | null | undefined;
    loginId: string;
    rotaryCd: string;
}

/**
 * 添付ファイルを登録するAPI
 */
export async function setAttachmentFile(props: setAttachmentProps): Promise<any>{
  
  try{
      if(props.fileinfo){
        const fileData = new FormData();
          fileData.append('file', props.fileinfo)

          //  API呼出し
          const response = await axios.post(process.env.REACT_APP_PATH + `/makeup/set-attachments`, fileData, {
            params:{
              loginId: props.loginId,
              rotaryCd: props.rotaryCd
            },
            headers: {
              'content-type': 'multipart/form-data',
            }
        })
        return JSON.parse(JSON.stringify(response.data))[0].id
      }
    }catch(error){
          console.warn(error)
    }
}